import {useQuery} from "@tanstack/react-query";

import {employeeHrKeys} from "../lib/query-keys";
import {employeeHrService} from "../services";

export function useWorkEligibility(officerProfileId: number | null, enabled = true) {
  const canQuery = enabled && officerProfileId != null && officerProfileId > 0;
  const {data, ...query} = useQuery({
    queryKey: employeeHrKeys.workEligibility(officerProfileId ?? 0),
    queryFn: () => employeeHrService.getOfficerWorkEligibility(officerProfileId as number),
    enabled: canQuery,
  });

  return {
    eligibility: data,
    ...query,
  };
}

export function useSelfWorkEligibility(enabled = true) {
  const {data, ...query} = useQuery({
    queryKey: employeeHrKeys.workEligibility("self"),
    queryFn: () => employeeHrService.getSelfWorkEligibility(),
    enabled,
  });

  return {
    eligibility: data,
    ...query,
  };
}
